export function UsersPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">User Management</h1>
        <p className="mt-1 text-sm text-gray-600">
          Manage users and their permissions
        </p>
      </div>

      <div className="bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900">Users</h3>
          <div className="mt-5">
            <div className="text-sm text-gray-500">No users to display.</div>
          </div>
        </div>
      </div>
    </div>
  );
}
